import { useCallback } from "react";
import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
const util = createTrackingUtils({
    name: "flights_funnel_sr_auto_load_offers_mobile",
    defaultStage: 1,
    stages: {
        main: 1,
        inview: 2,
        family: 3
    },
    goals: {},
    goalsWithValue: []
});
export function useFlightsFunnelSrAutoLoadOffersMobile() {
    const { isFamily } = useProfiler();
    const trackStages = useCallback(() => {
        util.stages.inview();
        if (isFamily())
            util.stages.family();
    }, [isFamily]);
    return { trackStages };
}
export default util;
